import Vue from "vue";

export default {

    state : () => ({
        basket         : {},
        total_sum      : 0,
        easy_clean_sum : 0,
        discount_sum   : 0,
        default_sum    : 0
    }),

    actions : {
        ADD_BASKET_ITEM    : ( context, payload ) =>
        {
            let formData = new FormData();
            formData.append("bid", payload.id);
            formData.append("quantity", payload.quantity);
            if(payload.easy_clean)
            {
                formData.append("easy_clean", "Y");
            }
            fetch("/api/basket/items/add/", {
                method : "POST",
                body   : formData
            })
            .then(response => response.json())
            .then(resp =>
            {
                if(resp.success !== true)
                {
                    window.toast.error("Ошибка: " + resp.message);
                }
                else
                {
                    window.toast.success("<a href=\"/basket/\">Товар успешно добавлен в корзину!</a>");
                    if(resp.data)
                    {
                        if(resp.data.basket === [])
                        {
                            this.state.basket = {};
                            context.commit("SET_BASKET_INFO", 0);
                            context.commit("SET_EASY_CLEAN_SUM", 0);
                            context.commit("SET_DEFAULT_SUM", 0);
                            context.commit("SET_DISCOUNT_SUM", 0);
                        }
                        else
                        {
                            context.commit("SET_BASKET", resp.data.basket.basket);
                            context.commit("SET_TOTAL_SUM", resp.data.basket.total_sum);
                            context.commit("SET_DISCOUNT_SUM", resp.data.basket.discount_sum);
                            context.commit("SET_EASY_CLEAN_SUM", resp.data.basket.easy_clean_sum);
                            context.commit("SET_DEFAULT_SUM", resp.data.basket.default_sum);
                        }
                        if(resp.data.errors)
                        {
                            window.toast.error(resp.data.errors.message);
                            context.commit("SET_BASKET_ITEM_QUANTITY", {
                                "bid" : payload.bid,
                                "quantity" : resp.data.errors.quantity
                            });
                        }
                    }
                }
            });
        },
        REMOVE_BASKET_ITEM : ( context, payload ) =>
        {
            context.commit("DEL_BASKET_ITEM", payload);
        },
        SET_QUANTITY       : ( context, payload ) =>
        {
            return new Promise(function (resolve)
            {
                if(payload.quantity === 0)
                {
                    let formData = new FormData();
                    formData.append("bid", payload.bid);
                    fetch("/api/basket/items/delete/", {
                        method : "POST",
                        body   : formData
                    })
                    .then(response => response.json())
                    .then(resp =>
                    {
                        if(resp.success !== true)
                        {
                            window.toast.error("Ошибка: " + resp.message);
                            return;
                        }
                        else
                        {
                            window.toast.success("<a href=\"/basket/\">Товар успешно удален из корзины!</a>");
                            return resp.data;
                        }
                    })
                    .then(data =>
                    {
                        if(data)
                        {
                            if(data === [])
                            {
                                this.state.basket = {};
                                context.commit("SET_BASKET_INFO", 0);
                                context.commit("SET_EASY_CLEAN_SUM", 0);
                                context.commit("SET_DEFAULT_SUM", 0);
                                context.commit("SET_DISCOUNT_SUM", 0);
                            }
                            else
                            {
                                context.commit("SET_BASKET", data.basket);
                                context.commit("SET_TOTAL_SUM", data.total_sum);
                                context.commit("SET_DISCOUNT_SUM", data.discount_sum);
                                context.commit("SET_EASY_CLEAN_SUM", data.easy_clean_sum);
                                context.commit("SET_DEFAULT_SUM", data.default_sum);
                            }
                        }
                    });
                }
                else
                {
                    let formData = new FormData();
                    formData.append("bid", payload.bid);
                    formData.append("quantity", payload.quantity);
                    // formData.append('easy_clean', payload.easy_clean ? 'Y' : 'N');
                    fetch("/api/basket/items/change/", {
                        method : "POST",
                        body   : formData
                    })
                    .then(response => response.json())
                    .then(resp =>
                    {
                        if(resp.success !== true)
                        {
                            alert(resp.message);
                        }
                        else
                        {
                            return resp.data;
                        }
                    })
                    .then(data =>
                    {
                        if(data.basket === [])
                        {
                            this.state.basket = {};
                            context.commit("SET_BASKET_INFO", 0);
                            context.commit("SET_EASY_CLEAN_SUM", 0);
                            context.commit("SET_DEFAULT_SUM", 0);
                            context.commit("SET_DISCOUNT_SUM", 0);
                        }
                        else
                        {
                            context.commit("SET_BASKET", data.basket.basket);
                            context.commit("SET_TOTAL_SUM", data.basket.total_sum);
                            context.commit("SET_DISCOUNT_SUM", data.basket.discount_sum);
                            context.commit("SET_EASY_CLEAN_SUM", data.basket.easy_clean_sum);
                            context.commit("SET_DEFAULT_SUM", data.basket.default_sum);
                        }
                        if(data.errors)
                        {
                            window.toast.error(data.errors.message);
                            context.commit("SET_BASKET_ITEM_QUANTITY", {
                                "bid"      : payload.bid,
                                "quantity" : data.errors.quantity
                            });
                            resolve(data.errors.quantity);
                        }
                        else
                            resolve(payload.quantity);
                    });
                }
            });
        },
        GET_BASKET         : async( context ) =>
        {
            fetch("/api/basket/")
            .then(async response => await response.json())
            .then(resp =>
            {
                if(resp.success !== true)
                {
                    alert(resp.message);
                }
                else
                {
                    if(resp.data)
                    {
                        if(resp.data === [])
                        {
                            this.state.basket = {};
                            context.commit("SET_BASKET_INFO", 0);
                            context.commit("SET_EASY_CLEAN_SUM", 0);
                            context.commit("SET_DEFAULT_SUM", 0);
                            context.commit("SET_DISCOUNT_SUM", 0);
                        }
                        else
                        {
                            context.commit("SET_BASKET", resp.data.basket);
                            context.commit("SET_TOTAL_SUM", resp.data.total_sum);
                            context.commit("SET_DISCOUNT_SUM", resp.data.discount_sum);
                            context.commit("SET_EASY_CLEAN_SUM", resp.data.easy_clean_sum);
                            context.commit("SET_DEFAULT_SUM", resp.data.default_sum);
                        }
                    }
                }
            });
        },
        SET_EASY_CLEAN     : ( context, payload ) =>
        {
            let formData = new FormData();
            formData.append("bid", payload.bid);
            formData.append("easy_clean", payload.easy_clean ? "Y" : "N");
            fetch("/api/basket/items/change/", {
                method : "POST",
                body   : formData
            })
            .then(response => response.json())
            .then(resp =>
            {
                if(resp.success !== true)
                {
                    alert(resp.message);
                }
                else
                {
                    if(resp.data)
                    {
                        if(resp.data === [])
                        {
                            this.state.basket = {};
                            context.commit("SET_BASKET_INFO", 0);
                            context.commit("SET_EASY_CLEAN_SUM", 0);
                            context.commit("SET_DEFAULT_SUM", 0);
                            context.commit("SET_DISCOUNT_SUM", 0);
                        }
                        else
                        {
                            context.commit("SET_BASKET", resp.data.basket);
                            context.commit("SET_TOTAL_SUM", resp.data.total_sum);
                            context.commit("SET_DISCOUNT_SUM", resp.data.discount_sum);
                            context.commit("SET_EASY_CLEAN_SUM", resp.data.easy_clean_sum);
                            context.commit("SET_DEFAULT_SUM", resp.data.default_sum);
                        }
                    }
                }
            });
        },
        CLEAR_BASKET       : ( context ) =>
        {
            fetch("/api/basket/clear/")
            .then(async response => await response.json())
            .then(resp =>
            {
                if(resp.success !== true)
                {
                    alert(resp.message);
                }
                else
                {
                    context.commit("DELETE_BASKET");
                }
            });
        }
    },

    mutations : {
        DELETE_BASKET            : ( state ) =>
        {
            state.basket = {};
        },
        SET_BASKET               : ( state, basket ) =>
        {
            for(let bItem in basket)
                Vue.set(state.basket, basket[bItem].bid, basket[bItem]);
        },
        SET_EASY_CLEAN_SUM       : ( state, sum ) =>
        {
            state.easy_clean_sum = sum;
        },
        SET_DISCOUNT_SUM         : ( state, sum ) =>
        {
            state.discount_sum = sum;
        },
        SET_DEFAULT_SUM          : ( state, sum ) =>
        {
            state.default_sum = sum;
        },
        SET_TOTAL_SUM            : ( state, sum ) =>
        {
            state.total_sum = sum;
        },
        DEL_BASKET_ITEM          : ( state, bid ) =>
        {
            if(state.basket[bid])
            {
                delete (state.basket[bid]);
            }
        },
        SET_BASKET_ITEM_QUANTITY : ( state, data ) =>
        {
            state.basket[data.bid].QUANTITY = data.quantity;
        }
    },

    getters : {}
};